import React from 'react';

import SharedDeleteVideofeedModal from '../../VideofeedsList/DeleteVideofeedModal';

type TDeleteVideofeedModal = {
  videofeedId: string;
  open: boolean;
  hasReferenceTimelines?: boolean;
  deleteCollection?: boolean;
  switchModal: () => void;
  fetchAll?: () => void;
  clearLocalStorageData?: () => void;
};

const DeleteVideofeedModal: React.FC<TDeleteVideofeedModal> = (props) => (
  <SharedDeleteVideofeedModal {...props} deleteTargetLabel="video" />
);

export default DeleteVideofeedModal;
